import { useCallback, useState } from "react";
import type { SocialProvider } from "@artha/types";
import { useSocialRedirectMutation } from "@/modules/auth/services/socialAuthClient";

export const useSocialLogin = () => {
  const [loadingProvider, setLoadingProvider] = useState<SocialProvider | null>(null);
  const [error, setError] = useState<string | null>(null);
  const socialRedirect = useSocialRedirectMutation();

  const loginWithProvider = useCallback(async (provider: SocialProvider, username?: string, referralToken?: string) => {
    try {
      setLoadingProvider(provider);
      setError(null);

      const { authorizationUrl } = await socialRedirect.mutateAsync({ provider, username, referralToken });
      window.location.href = authorizationUrl;
    } catch (err) {
      const message = err instanceof Error ? err.message : "Failed to start social login";
      setError(message);
    } finally {
      setLoadingProvider(null);
    }
  }, [socialRedirect]);

  return {
    loginWithProvider,
    loadingProvider,
    error,
    isLoading: loadingProvider !== null || socialRedirect.isPending,
  };
};
